import React, { useCallback, useEffect, useState } from "react";
import { Spinner, Table } from "react-bootstrap";
import userIcon from "../../../../Assets/images/user.png";
import { get } from "../../../../helpers/api_helper";
import Loader from "../../../../components/shared/Loader";
function UserTable() {
  const [userData, setUserData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const itemsPerPage = 10;

  const fetchUser = useCallback(
    async (page = 1) => {
      setLoading(true);
      try {
        const response = await get(
          `/user/admin/users?page=${page}&limit=${itemsPerPage}`
        );

        if (response?.success) {
          setUserData(response?.data?.items || []);
          setTotalPages(response?.data?.totalPages || 0);
        } else {
          console.log("Failed to fetch users");
          setUserData([]);
        }
      } catch (error) {
        console.log("An error occurred while fetching users", error);
      } finally {
        setLoading(false);
      }
    },
    [itemsPerPage]
  );

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  return (
    <div className="cardBox p-3 h-100 commonTable">
      <div
        className="top px-3 pt-2 d-flex align-items-center justify-content-between gap-10"
        style={{ background: "#F5F7FA" }}
      >
        <h6 className="m-0 fw-sbold">New Customer List </h6>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <Table responsive>
        <thead>
          <tr>
            <th className="fw-normal border-0">Customer</th>
            <th className="fw-normal border-0">Email</th>
            <th className="fw-normal border-0">Phone Number</th>
            <th className="fw-normal border-0">Created at</th>
            <th className="fw-normal border-0">Status</th>
          </tr>
        </thead>
        <tbody>
          {userData.length > 0 ? (
            userData?.map((user) => (
              <tr key={user?._id}>
                <td>
                  <div className="d-flex align-items-center profile">
                    <div className="imgWrp rounded-circle me-2">
                      <img
                        src={user?.profileImage ? user?.profileImage : userIcon}
                        alt="User Icon"
                        className="img-fluid rounded-circle"
                        style={{ height: 30, width: 30 }}
                      />
                    </div>
                    <div className="content">
                      <p className="m-0 fw-sbold">{user?.name || "-"}</p>
                    </div>
                  </div>
                </td>
                <td>{user?.email}</td>
                <td>{user?.phone || "-"}</td>
                <td>{new Date(user?.createdAt).toLocaleString()}</td>
                <td className="text-capitalize">{user?.status}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center">
                No users found
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      )}
      {!loading && userData.length === 0 && (
        <div className="text-center my-4">
          <h6>No new users yet</h6>
        </div>
      )}
    </div>
  )
}

export default UserTable;
